import { forwardRef } from "react";

import { Form } from "@shared/components/Form";

import { FormAutocompleteProps } from "@shared/components/Form/types";
import { getBooksService } from "@modules/books/services/queries/listBooks/service";

export const BooksAutocomplete = forwardRef<
  HTMLInputElement,
  Omit<FormAutocompleteProps, "options">
>((props, ref) => {
  return <Form.Autocomplete {...props} ref={ref} queryHook={getBooksService} />;
});

BooksAutocomplete.displayName = "BooksAutocomplete";
